import React from 'react'

export const Men = () => {
  return (<div className='border flex gap-10 bg-white justify-between p-5 m-auto' >
      <div className="">
        <div className="border bg-gray-200 rounded px-2 font-bold mb-2 ">Top & Bottom Wear</div>
        <ul>
            <li>T-Shirts</li>
            <li>Polo T Shirt</li>
            <li>Casual Shirts</li>
            <li>Casual Shirts</li>
            <li>Formal Shirts</li>
            <li>Suits & Blazers</li>
            <li>Jackets</li>
            <li>Sweaters & Seratshirts</li>
            <li>Jeans</li>
            <li>Casuals Trousers</li>
            <li>Formals Trousers</li>
            <li>Formal Trousers</li>
            <li>Joggers</li>
            <li>Shorts</li>
         
        </ul>
      </div>
      <div className="">
        <div className="border px-2 font-bold mb-2 bg-gray-200 rounded">Ethnic & Sports Wear</div>
        <ul>
            <li>Kurtas</li>
            <li>Ethnic Wears Sets</li>
            <li>Nehru Jackets</li>
            <li>Ethnic Bottom wear</li>
            <li>T-shirt</li>
            <li>Shorts</li>
            <li>Track Paints</li>
            <li>Track Suits</li>
            <li>Jeans & Jeggings</li>
            <li>Trousers & Pants</li>
         
         
        </ul>
      </div>
      <div className="">
        <div className="border px-2 font-bold mb-2 bg-gray-200 rounded">Footwears</div>
        <ul>
            <li>Casuals Shoes</li>
            <li>Formals Shoes</li>
            <li>Sports Shoes</li>
            <li>Shoes</li>
            <li>Juties</li>
            <li>Mojaris</li>
            <li>Slipers Sets</li>
            <li>Sandles</li>
            <li>Socks</li>
            <li>Belts, Bag Wear</li>
            <li>Wallets</li>
            <li>Sunglassess</li>
      
        </ul>
      </div>
      <div className="">
        <div className="border px-2 font-bold mb-2 bg-gray-200 rounded">Accessories</div>
        <ul>
            <li>Caps & Hats</li>
            <li> Lapel Pins & Brooch</li>
            <li>Ties & Pocket Squares</li>
            <li>Cuffinks & Bracekets </li>
            <li>Handkerchiefs</li>
            <li>Headphones & Speakers</li>
            <li>Innerwears</li>
            <li>Brief</li>
            <li>Boxes</li>
            <li>Vests</li>
           
        </ul>
      </div>
      <div className="">
        <div className="border px-2 font-bold mb-2 bg-gray-200 rounded">Brnad</div>
        <ul>
            <li>Arrow</li>
            <li>US Polo Assn</li>
            <li>Aeropostate</li>
            <li>Campus Sutra</li>
            <li>Ruggers</li>
            <li>Canary London</li>
            <li>Hang Up</li>
            <li>Alcis</li>
            <li>Pluss</li>
          
        </ul>
      </div>
    </div>

  )
}


